import React from "react"
import { Tabs } from "@mantine/core"
import classes from "@/components/ProfileSupporter/SupporterContactCardData.module.css"

export const SupporterContactCardData = ({ data }) => {
    const rules = {
        LargeAvatarCircleDiameter: "94px",
    }

    const showPacTab = data.pacItems.some((item) => item.text)
    const showSecondaryTab = data.secondaryItems.some((item) => item.text)
    const circleDiameter = parseInt(rules.LargeAvatarCircleDiameter, 10)
    const circleAreaPadding = 18
    const circleAreaWidth = circleDiameter + circleAreaPadding

    return (
        <Tabs className={classes.container} defaultValue="primary">
            <Tabs.List className={classes.tabs}>
                <Tabs.Tab className={classes.tab} value="primary">
                    primary
                </Tabs.Tab>
                {showSecondaryTab && (
                    <Tabs.Tab className={classes.tab} value="secondary">
                        Secondary
                    </Tabs.Tab>
                )}
                {showPacTab && (
                    <Tabs.Tab className={classes.tab} value="pac">
                        PAC
                    </Tabs.Tab>
                )}
            </Tabs.List>

            <div className={classes.info}>
                <Tabs.Panel value="primary">
                    <div
                        style={{ paddingRight: `${circleAreaWidth}px`, minWidth: `calc(50% + ${circleAreaWidth}px)` }}
                        className={classes.detailsContainer}
                    >
                        {data.detailItems &&
                            data.detailItems.map(
                                (item) =>
                                    item.text && (
                                        <div
                                            className={classes.detailItem}
                                            key={item.key || `${item.label}-${item.text}`}
                                        >
                                            {item.label && <span className={classes.detailLabel}>{item.label}</span>}
                                            {item.text && <span className={classes.detailText}>{item.text}</span>}
                                        </div>
                                    ),
                            )}
                    </div>
                </Tabs.Panel>

                <Tabs.Panel value="secondary">
                    <div
                        style={{ paddingRight: `${circleAreaWidth}px`, minWidth: `calc(50% + ${circleAreaWidth}px)` }}
                        className={classes.detailsContainer}
                    >
                        {data.secondaryItems &&
                            data.secondaryItems.map(
                                (item) =>
                                    item.text && (
                                        <div
                                            className={classes.detailItem}
                                            key={item.key || `${item.label}-${item.text}`}
                                        >
                                            {item.label && <span className={classes.detailLabel}>{item.label}</span>}
                                            {item.text && <span className={classes.detailText}>{item.text}</span>}
                                        </div>
                                    ),
                            )}
                    </div>
                </Tabs.Panel>

                <Tabs.Panel value="pac">
                    <div
                        style={{ paddingRight: `${circleAreaWidth}px`, minWidth: `calc(50% + ${circleAreaWidth}px)` }}
                        className={classes.detailsContainer}
                    >
                        {data.pacItems &&
                            data.pacItems.map(
                                (item) =>
                                    item.text && (
                                        <div
                                            className={classes.detailItem}
                                            key={item.key || `${item.label}-${item.text}`}
                                        >
                                            {item.label && <span className={classes.detailLabel}>{item.label}</span>}
                                            {item.text && <span className={classes.detailText}>{item.text}</span>}
                                        </div>
                                    ),
                            )}
                    </div>
                </Tabs.Panel>
            </div>
        </Tabs>
    )
}
